import React from 'react';
import DocumentTitle from 'react-document-title';
import {Provider} from 'react-redux';
import {Route, Redirect, Switch} from 'react-router-dom';
import {ConnectedRouter} from 'connected-react-router';
import {PersistGate} from 'redux-persist/lib/integration/react';
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import {bugsnagAPIKey} from './configs/constants';
import {store, history, persistor} from './store';
import {Layout, ErrorPage, UpgradeBrowsersWrapper} from './components/common';
import AppErrorFallback from './components/common/AppErrorFallback';
import RequireAuthenticationHoc from './components/Auth/RequireAuthHoc';
import {
  AuthPageContainer,
  LobbyPageContainer,
  GamePageContainer,
  ProfilePageContainer,
  LeaderboardContainer,
  TreasureChestContainer,
  TreasureRedemptionContainer,
  PageContainer,
  GiftContainer,
} from './containers';
import UnilinkContainer from './containers/UnilinksContainer';

const bugsnagClient = bugsnag({
  apiKey: bugsnagAPIKey,
  collectUserIp: false,
  appVersion: process.env.APP_VERSION,
  releaseStage: process.env.NODE_ENV,
});
bugsnagClient.use(bugsnagReact, React);

const ErrorBoundary = bugsnagClient.getPlugin('react');

const App = () => (
  <ErrorBoundary FallbackComponent={AppErrorFallback}>
    <DocumentTitle title="Yak Network">
      <Provider store={store}>
        <PersistGate
          loading={<div><h1>LOADING</h1></div>}
          persistor={persistor}
        >
          <ConnectedRouter history={history}>
            <Layout>
              <Switch>
                <Redirect from="/" to="/sign-in" exact/>
                <Route path="/sign-in" component={AuthPageContainer}/>
                <Route path="/forgot-password" component={AuthPageContainer}/>
                <Route path="/reset-password/:token" component={AuthPageContainer}/>
                <Route path="/sign-up" component={AuthPageContainer}/>
                <Route path="/complete-profile" component={RequireAuthenticationHoc(ProfilePageContainer)}/>
                <Route path="/lobby" component={RequireAuthenticationHoc(UpgradeBrowsersWrapper(LobbyPageContainer))}/>
                <Route path="/game/:gameId" component={RequireAuthenticationHoc(UpgradeBrowsersWrapper(GamePageContainer))}/>
                <Route path="/profile" component={RequireAuthenticationHoc(ProfilePageContainer)}/>
                <Route path="/leaderboard" component={RequireAuthenticationHoc(LeaderboardContainer)}/>
                <Route path="/treasure-chest" component={RequireAuthenticationHoc(TreasureChestContainer)}/>
                <Route path="/gift" component={RequireAuthenticationHoc(GiftContainer)}/>
                <Route path="/redemption/:rid" component={TreasureRedemptionContainer}/>
                <Route path="/privacy" component={PageContainer}/>
                <Route path="/terms" component={PageContainer}/>
                <Route path="/link/:org/:appId/" component={UnilinkContainer}/>
                <Route component={ErrorPage}/>
              </Switch>
            </Layout>
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    </DocumentTitle>
  </ErrorBoundary>
);

export default App;
